const c = {
  name: "Lemon",
  dimensions: { width: 40, height: 28 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 28" style="enable-background:new 0 0 40 28;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.3,7c0,0.7-0.6,1.3-1.2,1.3c-0.7,0-1.2-0.6-1.2-1.3s0.6-1.2,1.2-1.2C12.7,5.8,13.3,6.3,13.3,7z"/>
		<path class="st0" d="M11,12.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C9.7,11.7,10.3,12.2,11,12.2z"
			/>
		<path class="st0" d="M16.3,10c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C15.7,8.8,16.3,9.3,16.3,10z"/>
		<path class="st0" d="M17,0c-3.9,0-7.4,1.6-9.9,4.1C5.5,5.7,4.2,7.7,3.6,10c-0.9,0.1-1.8,0.5-2.4,1.2C0.5,11.9,0,12.9,0,14
			c0,2.1,1.6,3.8,3.6,4c1.7,5.8,7.1,10,13.4,10h6c3.9,0,7.4-1.6,9.9-4.1c1.6-1.6,2.9-3.6,3.5-5.9c0.9-0.1,1.8-0.5,2.4-1.2
			c0.7-0.7,1.2-1.7,1.2-2.8c0-2.1-1.6-3.8-3.6-4C34.7,4.2,29.4,0,23,0H17z M8.5,5.5C10.7,3.3,13.7,2,17,2h6c5.7,0,10.4,3.9,11.7,9.2
			l0.2,0.8H36c1.1,0,2,0.9,2,2c0,0.6-0.2,1.1-0.6,1.4C37.1,15.8,36.6,16,36,16h-1.1l-0.2,0.8c-0.5,2.2-1.6,4.2-3.2,5.7
			C29.3,24.7,26.3,26,23,26h-6c-5.7,0-10.4-3.9-11.7-9.2L5.1,16H4c-1.1,0-2-0.9-2-2c0-0.6,0.2-1.1,0.6-1.4C2.9,12.2,3.4,12,4,12h1.1
			l0.2-0.8C5.8,9,7,7.1,8.5,5.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Lemon
};
